import logo from './logo.svg';
import React, { Component } from 'react';
import { BrowserRouter as Router, Route} from "react-router-dom";
import { Layout, Menu, Space, PageHeader, Carousel, Notification, Modal  } from '@arco-design/web-react';

import MAIN from './pages/main'


import './App.css';
import "@arco-design/web-react/dist/css/arco.css";
import NAVBAR from './pages/navbar';
import ScaledImage from './comp/my-img';

import * as utils from "./utils.js"
import MyComp from './comp/my-comp';
const Sider = Layout.Sider;
const Header = Layout.Header;
const Footer = Layout.Footer;
const Content = Layout.Content;

const MenuItem = Menu.Item;
const SubMenu = Menu.SubMenu;


export default class App extends MyComp{
  constructor(props) {
    super(props);
    this.state = {
      winWidth: 0,
      winHeight: 100,

      language: 'ch',
    }

    this.handleResize = this.handleResize.bind(this);
  }




  getBody(){
    // return (
    //   <Space>
    //     {this.getBannerLink()}
    //   </Space>
    // )

  }

  getTopPanel(){
    let {winWidth} = this.state
    if(winWidth == 0){
      return
    }
    let rate = winWidth/2027
    return (
      <div>
        <div style={{width:winWidth, height: 38.5*rate,backgroundColor:'#353A40'}}></div>
        <div style={{width:winWidth, height: 38.5*rate,backgroundColor:'#FAC926'}}></div>
      </div>
    )
  }
  getBotPanel(){
    let {winWidth, language} = this.state
    if(winWidth == 0){
      return
    }

    let languageFolder = utils.GetLanguageFolder(language)

    let rate = winWidth/2027
    let imgPath = `../imgs/${languageFolder}img_bot.png`
    let telStr = '联系电话'
    if(language == 'en'){
      telStr = 'Contact Phone Number'
    }else if(language == 'de'){
      telStr = 'Kontakttelefonnummer'
    }
    return (
      <Space align='start' style={{backgroundColor:'#FBC925', width: winWidth, position:'relative'}}>
        <img src={imgPath} style={{width:winWidth, aspectRatio:'auto'}} />
        {this.getBeian()}

        <div style={{position:'absolute',width: 65*rate, height: 65*rate, left: 1730*rate, top: 290*rate}} onClick={()=>{
            // Notification.success({
            //     title: '点击小红书',
            //     content: "",
            // })
            utils.openUrl('https://www.xiaohongshu.com/user/profile/628f2a1a00000000210288fd?xhsshare=CopyLink&appuid=628f2a1a00000000210288fd&apptime=1723008496&share_id=8bc13fde61ff49229e56a17feda03bf4')
        }}></div>
        <div style={{position:'absolute',width: 65*rate, height: 65*rate, left: 1800*rate, top: 290*rate}} onClick={()=>{
            // Notification.success({
            //     title: '点击tel',
            //     content: "",
            // })
            Modal.success({
              title: `${telStr}：13982194888`,
            });
        }}></div>
      </Space>
    )
  }
  getBeian(){
    let {winWidth} = this.state
    if(winWidth == 0){
      return
    }
    let rate = winWidth/2027
    return (
      <div style={{position:'absolute',width: '100vw',left: 0, top: 390*rate, backgroundColor:'#FBC925', }}>
        <Space direction='vertical' style={{width: '100vw', paddingBottom: 50}} align='center'>
          <div style={{width:'84vw', height: 0.5, backgroundColor: '#343A40'}}></div>
          <div style={{color:'#343A40', fontSize: 12}}>
            {/* <span>斯奈德音乐</span> */}
            
            <img src='../imgs/beian.png' style={{width:14, aspectRatio:'auto'}} /><span onClick={()=>{
              utils.openUrl('https://beian.mps.gov.cn/#/query/webSearch?code=51010702043185')
            }}>川公网安备 51010702043185号</span>
            <br></br>
            <span  onClick={()=>{
              utils.openUrl('https://beian.miit.gov.cn/#/Integrated/index')
            }}>蜀ICP备2024088993号-2</span>
          </div>

        </Space>


    </div>
    )
  }
  render() {
    const {language} = this.state
    let is_music_terms = window.location.href.indexOf('music_terms') != -1
    let hideTop = is_music_terms
    return (
      // <Router  basename='/music'>
      <Router>
      <div  className="App" >
          {!hideTop && <NAVBAR language={language} onSetLanguage={
            (_language)=>{
              this.setState({
                language: _language
              })
            }
          }/>}
          {!hideTop && this.getTopPanel()}
          <MAIN  language={language}/>
          {this.getBotPanel()}
      </div>
      </Router>

    );

    return (
      // <Router  basename='/music'>
      <Router>
      <div  className="App" >
        <Layout style={{overflowX: 'hidden'}}>
          <Header>
            <NAVBAR language={language} onSetLanguage={
              (_language)=>{
                this.setState({
                  language: _language
                })
              }
            }/>
          </Header>
          <Content>
            {this.getTopPanel()}
            <MAIN  language={language}/>
          </Content>
          <Footer>
            {this.getBotPanel()}
          </Footer>
        </Layout>
      </div>
      </Router>

    );
  }
}

